import { BUSINESS } from "./businessInfo";
import { FacebookIcon, LinkedinIcon, InstagramIcon, QuoraIcon } from "../components/SocialIcons";

const ICONS = {
  Facebook: FacebookIcon,
  LinkedIn: LinkedinIcon,
  Instagram: InstagramIcon,
  Quora: QuoraIcon,
};

export const SOCIAL_LINKS = BUSINESS.socialLinks.map((link) => ({
  ...link,
  Icon: ICONS[link.label] || LinkedinIcon,
}));
